export const request_general_lang={
  TH:{
    header_card:"คำร้องทั่วไป",
    request_id:"หมายเลขคำร้อง",
    request_date:"วันที่แจ้งคำร้อง",
    remark:"หมายเหตุ",
    customer_name:"ชื่อ-นามสกุล ผู้ยื่นคำร้อง",
    flag:"สถานะการใช้งาน",
    request_desc:"ความประสงค์",
    request_to:"ยื่นคำร้องต่อ",
    detail:"พิมพ์เอกสาร",
    search:"ค้นหา",
    add_request_general:"เพิ่มข้อมูลคำร้อง",
    back:"ย้อนกลับ",
    customer_error:"กรุณาเลือกผู้เสียค่าธรรมเนียม",
    customer_place:"ที่อยู่ ผู้ยื่นคำร้อง",
    customer_place_error:"กรุณาเลือกที่อยู่",
    request_to_error:"กรุณากรอกข้อมูลยืนคำร้องต่อ",
    requsst_desc_error:"กรุณากรอกข้อมูลความประสงค์",
    opinion:"ความเห็นของเจ้าหน้าที่",
    opinion_error:"กรุณากรอกข้อมูลความเห็นของเจ้าหน้าที่",
    command_error:"กรุณากรอกคำสั่ง",
    command:"คำสั่ง",
    save:"บันทึก",
    save_command:"บันทึกคำสั่ง",
    cancel:"ยกเลิก",
    saved:"ข้อมูลถูกบันทึกเรียบร้อยแล้ว!",
    errored:"ไม่สามารถบันทึกข้อมูลได้!",
    update:"อัพเดทคำสั่ง",
    approve:"อนุมัติ",
    notapprove:"ไม่อนุมัติ",
    status:"สถานะการอนุมัติ",

  },
  EN:{
    header_card:"Request (General)",
    request_id:"Request Id",
    request_date:"Request Date",
    remark:"Remark",
    customer_name:"Name-Surname Customer",
    flag:"Status",
    request:"Request",
    request_to:"Request to",
    detail:"Print",
    search:"Search",
    add_request_general:"Add Request General",
    back:"Back",
    customer_error:"Please choose customer",
    customer_place:"Customer Address",
    customer_place_error:"Please choose address",
    request_to_error:"Please input request to",
    request_desc:"Customer request",
    requsst_desc_error:"Please input customer request",
    opinion:"Opinion of the staff",
    opinion_error:"Please input opinion",
    command_error:"Please input opinion",
    command:"Command",
    save:"Save",
    save_command:"Save Command",
    cancel:"Cancel",
    saved:"data was saved!",
    errored:"Can't save data!",
    update:"Update Command",
    approve:"Approve",
    notapprove:"Not approve",
    status:"Status",

  }
}
